module.exports = __webpack_public_path__ + "img/insta.png?02ebd6896d578ab90107473a55a55e4e";